import React from 'react';
import { FileCheck } from 'lucide-react';

export const DpaPage: React.FC = () => {
  return (
    <div className="canvas-dark" style={{ minHeight: '100vh', paddingTop: '130px', paddingBottom: '80px', backgroundColor: '#121212' }}>
      
      {/* Hero */}
      <header className="container" style={{ padding: '0 20px 48px', maxWidth: '880px' }}>
        <div className="eyebrow" style={{ marginBottom: '12px' }}>GDPR Article 28 Compliance</div>
        <h1 
          style={{
            fontFamily: "'Outfit', sans-serif",
            fontSize: 'clamp(32px, 5vw, 48px)',
            fontWeight: 400,
            lineHeight: 1.2,
            letterSpacing: '-1px',
            color: '#FFFFFF',
            margin: '0 0 16px'
          }}
        >
          Data Processing Agreement (DPA)
        </h1>
        <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: '15px', color: '#D7D7D7', lineHeight: 1.6, margin: 0 }}>
          Standard Contractual Clauses &bull; Technical &amp; Organizational Measures (TOMs) &bull; Sub-processor Authorizations.
        </p>
      </header>

      {/* Content Layout */}
      <div className="container" style={{ maxWidth: '880px', padding: '0 20px' }}>
        <div 
          style={{ 
            backgroundColor: '#1A1A1A', 
            border: '1px solid rgba(255, 255, 255, 0.08)', 
            borderRadius: '8px', 
            padding: '40px 36px', 
            display: 'flex', 
            flexDirection: 'column', 
            gap: '36px' 
          }}
        >
          <div 
            style={{ 
              backgroundColor: '#121212', 
              border: '1px solid #374151', 
              borderRadius: '8px', 
              padding: '22px 24px' 
            }}
          >
            <h4 style={{ color: '#FFFFFF', fontSize: '15px', fontWeight: 500, display: 'flex', alignItems: 'center', gap: '8px', margin: 0 }}>
              <FileCheck size={18} color="#6D7CFF" /> Pre-Signed Enterprise DPA
            </h4>
            <p style={{ color: '#D7D7D7', fontSize: '14px', marginTop: '10px', lineHeight: 1.6 }}>
              This Data Processing Agreement (&quot;DPA&quot;) supplements the Draway Auth Terms of Service and applies to the processing of personal data subject to the General Data Protection Regulation (GDPR), UK GDPR, and Swiss FADP.
            </p>
          </div>

          <section>
            <h3 style={{ color: '#FFFFFF', fontSize: '18px', fontWeight: 500, marginBottom: '12px' }}>1. Roles &amp; Scope of Processing</h3>
            <p style={{ color: '#D7D7D7', fontSize: '14px', lineHeight: 1.7 }}>
              Customer acts as the <strong style={{ color: '#FFFFFF' }}>Data Controller</strong>, and Draway acts as the <strong style={{ color: '#FFFFFF' }}>Data Processor</strong>. Draway processes personal data solely on documented instructions from Customer, including the transmission of authentication tokens, multi-factor codes, and security telemetry.
            </p>
          </section>

          <section>
            <h3 style={{ color: '#FFFFFF', fontSize: '18px', fontWeight: 500, marginBottom: '12px' }}>2. Technical &amp; Organizational Measures (TOMs)</h3>
            <p style={{ color: '#D7D7D7', fontSize: '14px', lineHeight: 1.7 }}>
              Draway implements and maintains the following security baselines:
            </p>
            <ul style={{ color: '#D7D7D7', fontSize: '14px', marginTop: '10px', paddingLeft: '20px', lineHeight: 1.7 }}>
              <li><strong style={{ color: '#FFFFFF' }}>Encryption in Transit:</strong> TLS 1.3 enforced on all external endpoints and internal cluster service-mesh communications.</li>
              <li><strong style={{ color: '#FFFFFF' }}>Encryption at Rest:</strong> AES-256-GCM encryption for all sensitive secrets, with hardware-backed key management (AWS KMS).</li>
              <li><strong style={{ color: '#FFFFFF' }}>Access Control:</strong> Strict least-privilege RBAC, multi-factor hardware security keys (YubiKeys) mandated for all administrative engineering access.</li>
              <li><strong style={{ color: '#FFFFFF' }}>Audit Logging:</strong> Immutable, tamper-evident audit trails capturing administrative events, retained for a minimum of 365 days.</li>
            </ul>
          </section>

          <section>
            <h3 style={{ color: '#FFFFFF', fontSize: '18px', fontWeight: 500, marginBottom: '12px' }}>3. Data Incident Notification</h3>
            <p style={{ color: '#D7D7D7', fontSize: '14px', lineHeight: 1.7 }}>
              In the event of a confirmed security incident resulting in unlawful destruction, loss, alteration, or unauthorized disclosure of Customer Data, Draway shall notify Customer without undue delay and, where feasible, not later than <strong style={{ color: '#FFFFFF' }}>72 hours</strong> after becoming aware of the breach.
            </p>
          </section>

          <section>
            <h3 style={{ color: '#FFFFFF', fontSize: '18px', fontWeight: 500, marginBottom: '12px' }}>4. Audits &amp; Compliance Inquiries</h3>
            <p style={{ color: '#D7D7D7', fontSize: '14px', lineHeight: 1.7 }}>
              Upon written request, Draway shall provide Customer with summaries of third-party security audits, SOC2 Type II reports, and penetration testing summaries. Download an executed copy of this DPA by contacting <a href="mailto:compliance@draway.in" style={{ color: '#6D7CFF', textDecoration: 'underline' }}>compliance@draway.in</a>.
            </p>
          </section>

        </div>
      </div>

    </div>
  );
};

export default DpaPage;
